import { ReactNode } from 'react';
import { RightCheck, Warning } from '@core/ui';

export interface HealthCheckItemProps {
    children?: ReactNode;
    hasIssue: boolean;
    issueLabel: string;
    label: string;
}

export const HealthCheckItem = ({ children, hasIssue, issueLabel, label }: HealthCheckItemProps) => (
    <li className="flex gap-2">
        {hasIssue ? (
            <>
                <Warning classNames="size-5 flex-none fill-white" />
                <div>
                    {issueLabel}
                    {children && <div className="pt-2 text-sm">{children}</div>}
                </div>
            </>
        ) : (
            <>
                <RightCheck classNames="size-5 flex-none fill-success" /> {label}
            </>
        )}
    </li>
);
